
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Laut dem britischen Schlafcoach Nick Littlehales ist der stets proklamierte Achtstundenschlaf ein Märchen. Im Tagesverlauf des Menschen gebe es unterschiedliche Abschnitte, die natürlicherweise für Schlaf vorgesehen seien. Zudem dauere der durchschnittliche Schlafzyklus, in dem die verschiedenen Schlafphasen durchlaufen werden, gerade mal eineinhalb Stunden. `}<M mdxType="M">{`In seinem Ratgeber «Sleep. Schlafen wie die Profis» plädiert Littlehales deshalb dafür, den Schlaf in Zyklen à 90 Minuten aufzuteilen.`}</M>{` Er spricht dabei nicht mehr von Schlaf, sondern von mentalen und physischen Erholungsphasen, nicht mehr von Nickerchen, sondern von CRPs. Schläft man nach seiner sogenannten R90-Methode, zählt man nicht mehr die Schlafstunden pro Nacht, sondern die Zyklen, die man pro Woche geschlafen hat. `}<br /><br />{`
Wissenschaftlich geprüft ist die Methode nicht. Fest steht aber, dass sich einzelne Personen, die sich von Littlehales coachen liessen, nach der Umstellung fitter und leistungsstärker fühlten. `}<M mdxType="M">{`Zu ihnen gehört auch Profifussballer Cristiano Ronaldo. Er schläft fünfmal pro Tag in Embryostellung im frisch bezogenen Bett.`}</M>{` Dadurch umgehe er, so sein Argument, einem Leistungstief um die Mittagszeit. Littlehales selbst betont übrigens einen weiteren Vorteil seiner Methode: Die Schlafzyklen pro Woche zu zählen, nehme den Druck von der einzelnen Nacht. Es sei kein Problem, wenn man zwei Nächte in der Woche schlecht schlafe – solange man genügend CRPs einbaut.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;